import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import { ToastProvider } from './Toast';
import Sidebar from './components/Sidebar';
import Dashboard from './pages/Dashboard';
import ProceduresList from './pages/ProceduresList';
import ProcedureDetail from './pages/ProcedureDetail';
import ProcedureForm from './pages/ProcedureForm';
import UsersPage from './pages/UsersPage';
import DepartmentsPage from './pages/DepartmentsPage';
import ActivityPage from './pages/ActivityPage';
import NotificationSettingsPage from './pages/NotificationSettingsPage';
import BackupPage from './pages/BackupPage';
import StatusesPage from './pages/StatusesPage';
import GroupsPage from './pages/GroupsPage';
import { LoginPage, SetupPage } from './pages/Auth';

function ProtectedLayout() {
  const { user, loading } = useAuth();

  if (loading) return <div style={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center', color: 'var(--gray-400)', fontSize: 15 }}>Ładowanie...</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div className="layout">
      <Sidebar />
      <div className="main">
        <div className="content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/procedures" element={<ProceduresList />} />
            <Route path="/procedures/new" element={<ProcedureForm />} />
            <Route path="/procedures/:id" element={<ProcedureDetail />} />
            <Route path="/procedures/:id/edit" element={<ProcedureForm />} />
            <Route path="/users" element={<UsersPage />} />
            <Route path="/departments" element={<DepartmentsPage />} />
            <Route path="/activity" element={<ActivityPage />} />
            <Route path="/notifications-settings" element={<NotificationSettingsPage />} />
            <Route path="/backup" element={<BackupPage />} />
            <Route path="/statuses" element={<StatusesPage />} />
            <Route path="/groups" element={<GroupsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/setup" element={<SetupPage />} />
            <Route path="/*" element={<ProtectedLayout />} />
          </Routes>
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
